import type { PotentialSupabaseMigrationProblem } from '~/types/chat';

interface SupabaseRendererProps extends PotentialSupabaseMigrationProblem {}

export function SupabaseRenderer({ ...error }: SupabaseRendererProps) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <div className="text-lg i-ph:x text-bolt-elements-icon-error"></div>
        Database action failed
      </div>
      <pre className="px-3 py-4 text-sm rounded-lg bg-bolt-elements-messages-background font-mono whitespace-pre-wrap text-bolt-elements-textSecondary text-[0.6rem] leading-4">
        {error.message}
      </pre>
    </div>
  );
}
